import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './main.scss';
import { ThemeProvider } from './contexts/ThemeContext';
import { SocketProvider } from './contexts/SocketContext';
import { BrandingProvider } from './contexts/BrandingContext';
import { PlanProvider } from './contexts/PlanContext';
import { BranchProvider } from './contexts/BranchContext';
import { PageTitleProvider } from './contexts/PageTitleContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrandingProvider>
      <PlanProvider>
        <BranchProvider>
          <ThemeProvider>
            <SocketProvider>
              <PageTitleProvider>
                <App />
              </PageTitleProvider>
            </SocketProvider>
          </ThemeProvider>
        </BranchProvider>
      </PlanProvider>
    </BrandingProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// ── PWA: Register service worker ──
// Register in all environments so install prompt works in dev too.
// In production Workbox generates the full caching SW; in dev public/sw.js is used.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('[PWA] Service Worker registered');

        // Detect updates — fire custom event so PWAUpdateToast can listen
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;

          newWorker.addEventListener('statechange', () => {
            if (
              newWorker.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              // New content is available; dispatch event for update toast
              window.dispatchEvent(
                new CustomEvent('sw-update-available', {
                  detail: { registration },
                })
              );
            }
          });
        });
      })
      .catch((err) => console.error('[PWA] SW registration failed:', err));
  });
}
